import {
  PATH_HOME,
  PATH_HOTEL_NIGHTS,
  PATH_PROFILE,
  PATH_SUBSCRIPTION,
  PATH_AIRPORTS,
} from "@hopper-b2b/hopper-utils";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Link, Menu, MenuItem } from "@mui/material";

export type UserMenuProps = {
  anchorEl?: HTMLElement | null;
  onClose?: () => void;
  onLogout: () => void;
  showSubscription?: boolean;
  showHotelPunchCard?: boolean;
  /** The trips link href, resolved by the navigation layer's HTS trips hook. */
  tripsHref: string;
  /** Whether the HTS Assist lobby is enabled, matching the hook's kill-switch semantics. */
  isHtsAssistLobby: boolean;
};

export const UserMenu = ({
  anchorEl,
  onClose,
  onLogout,
  showSubscription,
  showHotelPunchCard,
  tripsHref,
  isHtsAssistLobby,
}: UserMenuProps) => {
  const { t } = useI18nContext();

  return (
    <Menu keepMounted anchorEl={anchorEl} open={!!anchorEl} onClose={onClose}>
      <MenuItem
        component={Link}
        href={`${PATH_HOME}${PATH_PROFILE}`}
        color="textSecondary"
      >
        {t?.("myProfile")}
      </MenuItem>
      <MenuItem component={Link} href={tripsHref} color="textSecondary">
        {isHtsAssistLobby ? t?.("tripsAndSupport") : t?.("myTrips")}
      </MenuItem>
      {showSubscription && (
        <MenuItem
          component={Link}
          href={`${PATH_HOME}${PATH_SUBSCRIPTION}`}
          color="textSecondary"
        >
          {t?.("subscription")}
        </MenuItem>
      )}
      {showSubscription && (
        <MenuItem
          component={Link}
          href={`${PATH_HOME}${PATH_AIRPORTS}`}
          color="textSecondary"
        >
          {t?.("airports")}
        </MenuItem>
      )}
      {showHotelPunchCard && (
        <MenuItem
          component={Link}
          href={`${PATH_HOME}${PATH_HOTEL_NIGHTS}`}
          color="textSecondary"
        >
          {t?.("hotelNights")}
        </MenuItem>
      )}
      <MenuItem>
        <Link color="textSecondary" onClick={onLogout} underline="hover">
          {t?.("signOut")}
        </Link>
      </MenuItem>
    </Menu>
  );
};
